import React, { useState, useRef, useEffect } from "react";
import Cropper from "react-easy-crop";
import { Point, Area } from "react-easy-crop/types";
import { useSelector } from 'react-redux/es/hooks/useSelector';
import getCroppedImg from "./cropImage";
import ModalBase from "./ModalBase";
import { useDispatch } from "react-redux";
import systemSlice from "../../../../redux/systemSlice";
import PrimaryButton from "../../PrimaryButton";
import SecondaryButton from "../../SecondaryButton";
import { imageScaler } from "../../../../helper/ImageScaler";
import OtpInput from 'react-otp-input';
import { translate } from "../../../../utils/language";
import CreateAction from "../../../operational/createAction";

function OTPModal() {
    const [otp, setOtp] = useState('');
    const { createActionProps, resolveId } = useSelector((state: any) => state.systemSlice.OTPProps);
    const dispatch = useDispatch()

    const closeModal = () => {

        localStorage.removeItem("otp")
        localStorage.removeItem("transactionid")

        dispatch(systemSlice.actions.setOTPProps({}))
        setOtp("")

    }
    const saveImage = async () => {
        //@ts-ignore
        if (resolveId && globalThis?.[resolveId]) {
            localStorage.setItem("otp", otp)
            //@ts-ignore
            const response = await CreateAction({ ...createActionProps, hideToastMessages: true, showPreLoader: true })
            console.log(response)
            if (response?.error && response?.result?.data?.resultCode == "1000007") return
            //@ts-ignore
            globalThis?.[resolveId]?.(response)

            closeModal()


        }
    }

    const resend = async () => {
        //@ts-ignore
        if (resolveId && globalThis?.[resolveId]) {
            localStorage.removeItem("otp")
            localStorage.removeItem("transactionid")
            //@ts-ignore
            await CreateAction({ ...createActionProps })

        }
    }

    useEffect(() => {
        if (otp?.length === 6) {
            saveImage()
        }
    }, [otp])
    return (
        <>
            {createActionProps &&
                <>
                    <div className={`appear fixed inset-0 overflow-y-visible flex flex-col p-5 items-center top-0 left-0 z-[100]`}>
                        <div className='shadow' ></div>
                        <div className="bg-white p-8 w-[90%] md:w-[60%] xl:w-[600px] z-[500] overflow-visible h-auto m-auto rounded-2xl">

                            <div className='pb-2 my-2 flex items-center flex-col gap-[10px]'>
                                <p className="font-bold text-xl mb-2">{translate("AuthenticateAccount")}</p>
                                <p className="text-color-secondary block mb-5">{translate("pleaseEnterOTPCodeFromMail")}</p>
                                <OtpInput
                                    value={otp}
                                    onChange={setOtp}
                                    numInputs={6}
                                    inputType="number"
                                    inputStyle={"mx-[10px] text-[40px] bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 flex items-center justify-center"}
                                    renderInput={(props) => <input {...props} placeholder="*" />}
                                />

                            </div>
                            <div className='flex flex-row pt-1 justify-center gap-[15px]' >
                                <SecondaryButton value={"cancel"} onClick={() => { closeModal() }}></SecondaryButton>
                                <PrimaryButton value={"resend"} onClick={() => { resend() }}></PrimaryButton>
                                <PrimaryButton value={"send"} onClick={() => { saveImage() }}></PrimaryButton>
                                {/* {error && <div className='ml-auto pr-3 flex items-center text-red-500' >
                        {translate(error)}
                      </div>} */}
                            </div>
                        </div>
                    </div>
                </>
            }
        </>

    );
}

export default OTPModal

